import React from 'react'
import Body from './Body'

const ForgotPassword = () => {
    const _this = {}
    return (
        <Body {..._this} />
    )
}

export default ForgotPassword